/* eslint-disable no-unused-vars */
import ApiService from "../api.service";
import appConfig from "../../../app-config";

ApiService.init(appConfig.VUE_APP_ROOT_API);

const CallTypeService = {
  async getDefaultCallType() {
    const requestScreenData = {
      url: "api/CallType",
      top: "1",
      filter: `IsDefault eq  'Y'`,
    };

    return await ApiService.oDataGet(requestScreenData);
  },
};

export { CallTypeService };
